// JsFromRoutes CacheKey 7491a131ec5a4a9b04ac21480fe77d4e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  store: definePathHelper('get', '/integrations/store')
}
